import React, { Component } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table';
import {
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  EduQuizTableMenu,
  Loading,
  EduQuizAddEditModal
} from 'components';
import { injectIntl, defineMessages } from 'react-intl';
import { Icon, Image, Button } from 'semantic-ui-react';
import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './EduQuiz.css';
const cx = classNames.bind(styles);

class EduQuiz extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      quizData,
      loading,
      searchObj,
      handlePagination,
      currentPage,
      totalPages,
      checkFilter,
      executeFilter,
      cancelFilter,
      resetFilter,
      filterClose,
      onToggleModal,
      formStore,
      isModal,
      handleOnPost,
      eduAttachByAttachNo,
      getQuizInfo,
      quizRowInfo
    } = this.props;

    const columns = [
      {
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        minWidth: 80,
        headerClassName: 'react-table-th',
        className: cx('react-table-td text-align-center'),
        Cell: ({ original }) => {
          return (
            <EduQuizTableMenu
              isAuth={2}
              quizInfo={{ ...original }}
              isLoading={loading}
              onToggleModal={onToggleModal}
              getQuizInfo={getQuizInfo}
            />
          );
        }
      },
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'quizNo',
        resizable: false,
        sortable: true,
        minWidth: 70,
        headerClassName: 'react-table-th',
        className: cx('react-table-td text-align-center number-text'),
        Cell: ({ value }) => {
          return value ? value : '-';
        }
      },
      // {
      //   Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Quiz_1', defaultMessage: '퀴즈 유형' }))} />,
      //   accessor: 'quizType',
      //   resizable: false,
      //   sortable: false,
      //   minWidth: 80,
      //   // width: 100,
      //   headerClassName: 'react-table-th',
      //   className: cx('react-table-td text-align-center'),
      //   Cell: ({ value }) => {
      //     if (value === 1) {
      //       return '진위형';
      //     } else if (value === 2) {
      //       return '선다형';
      //     } else {
      //       return '-';
      //     }
      //   }
      // },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Quiz_2', defaultMessage: '퀴즈 내용' }))} />,
        accessor: 'quizContent',
        resizable: false,
        sortable: false,
        minWidth: 300,
        headerClassName: 'react-table-th',
        className: cx('react-table-td'),
        Cell: ({ value, original }) => {
          return (
            <div className={cx('ellipsis')} title={value}>{value ? value : '-'}</div>
          );
        }
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Quiz_8', defaultMessage: '교육 영상' }))} />,
        accessor: 'fileName',
        resizable: false,
        sortable: false,
        minWidth: 300,
        headerClassName: 'react-table-th',
        className: cx('react-table-td'),
        Cell: ({ value }) => {
          return (
            <div className={cx('ellipsis')} title={value}>{value ? value : '-'}</div>
          );
        }
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Quiz_3', defaultMessage: '정답' }))} />,
        accessor: 'quizSolution',
        resizable: false,
        sortable: false,
        minWidth: 80,
        headerClassName: 'react-table-th',
        className: cx('react-table-td text-align-center'),
        Cell: ({ row, value }) => {
          if (!!value) {
            return value === 1 ? 'O' : 'X';
            // if (row.quizType === 1) { // 진위형
            //   return value === 1 ? 'O' : 'X';
            // } else if (row.quizType === 2) { // 선다형
            //   return value;
            // }
          } else {
            return '-';
          }
        }
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Quiz_4', defaultMessage: '수정일' }))} />,
        accessor: 'modifyEpoch',
        resizable: false,
        sortable: true,
        minWidth: 120,
        headerClassName: 'react-table-th',
        className: cx('react-table-td text-align-center epoch'),
        Cell: ({ value }) => {
          return value ? common.timeFormatFromUTCEpoch(value) : '-';
        }
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Quiz_5', defaultMessage: '생성일' }))} />,
        accessor: 'regEpoch',
        resizable: false,
        sortable: true,
        minWidth: 120,
        headerClassName: 'react-table-th',
        className: cx('react-table-td text-align-center epoch'),
        Cell: ({ value }) => {
          return value ? common.timeFormatFromUTCEpoch(value) : '-';
        }
      }
    ];

    const { TbodyComponent: tbodyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('edu-quiz-wrap')}>
        <div className={cx('edu-quiz-header')}>
          <div className={cx('edu-quiz-title')}>
            {defineMessages(formatMessage({ id: 'Edu_57', defaultMessage: '퀴즈' }))}
          </div>
          <Button
            className="bt-style-gleam common-button-brand"
            size="small"
            content={defineMessages(formatMessage({ id: 'ModalEdu_6', defaultMessage: '등 록' }))}
            onClick={() => {
              handleOnPost();
            }}
          />
          {eduAttachByAttachNo.size > 0 &&
            <EduQuizAddEditModal
              onToggleModal={onToggleModal}
              formStore={formStore}
              isModal={isModal}
              quizData={quizData}
              isLoading={loading}
              eduAttachByAttachNo={eduAttachByAttachNo}
              quizRowInfo={quizRowInfo}
            />}
        </div>
        <div className={cx('react-table-area')}>
          <ReactTableSearch
            searchObj={searchObj}
            listData={quizData}
            // 필터
            checkFilter={checkFilter}
            executeFilter={executeFilter}
            cancelFilter={cancelFilter}
            resetFilter={resetFilter}
            // cancleCheck={cancleCheck}
            filterClose={filterClose}
          // executeFilter={executeFilter}
          // onFilterCancel={onFilterCancel}
          />
          <div className={'react-table'}>
            <ReactTable
              columns={columns}
              data={quizData}
              sortable={false}
              filterable={false}
              showPagination={false}
              showPageSizeOptions={false}
              defaultSorted={[{ id: 'quizNo', desc: false }]}
              loadingText={defineMessages(
                formatMessage({ id: 'ExamTemplateList_23', defaultMessage: '데이터 로딩중...' })
              )}
              LoadingComponent={() => <Loading active={loading} />}
              // FilterComponent={({ ...rest }) => <div />}
              TbodyComponent={({ ...rest }) => (
                <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                  <tbodyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '', quizData.length < 2 ? 'single' : '')} />
                </div>
              )}
              NoDataComponent={({ ...rest }) => (
                <div className={cx('noData-area')}>
                  <Image src="/img/table/nodata_icon.png" />
                  {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
                </div>
              )}
              minRows={quizData ? (quizData.length !== 0 && quizData.length < 2 ? 2 : quizData.length) : searchObj.defaultPageSize}
              getTheadThProps={(state, rowInfo, column) => {
                const filter = [];
                if (column) {
                  // 필터 처리
                  if (typeof searchObj.filterData[column.id] !== 'undefined') {
                    filter.push('isFiltered');
                  }
                  // 정렬 제공 안하는 header
                  if (!column.sortable) {
                    filter.push('no-sort');
                  }

                  return filter.length > 0
                    ? {
                      className: filter.join(' ')
                    }
                    : {};
                }
              }}
              getTrProps={(state, rowInfo, column) => {
                if (rowInfo && rowInfo.original && rowInfo.original.quizEnabled === 0) {
                  return {
                    className: 'delete-item'
                  };
                } else {
                  return {};
                }
              }}
            // {...rest}
            />
          </div>
          <ReactTablePagination
            currentPage={currentPage}
            totalPages={totalPages}
            handlePagination={handlePagination}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(EduQuiz);


// WEBPACK FOOTER //
// ./src/script/components/edu/EduQuiz.js